import { Pagination as MuiPagination } from "@mui/material";

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  perPage,
  totalRecords,
}) => {
  const handleChange = (event, value) => {
    console.log(value, currentPage, "currentPage");
    if (value !== currentPage) {
      onPageChange(value);
    }
  };

  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, totalRecords);

  return (
    <div className="row">
      <div className="col-sm-6 text-left" id="paginationContainer">
        <MuiPagination
          count={totalPages}
          page={currentPage}
          onChange={handleChange}
          variant="text"
          shape="rounded"
        />
      </div>
      <div className="col-sm-6 text-end" id="paginationContainer">
        {`Showing ${start} to ${end} of ${totalRecords} (${totalPages} Pages)`}
      </div>
    </div>
  );
};

export default Pagination;
